import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle:{width:800},
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>TÌM Ý CHO ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay:true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              Chọn một trong 2 đề dưới đây:<br>
              <b>Đề 1:</b>Viết đoạn văn nêu lý do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe <br>
              <b>Đề 2:</b>Viết đoạn văn nêu lý do yêu thích một câu chuyện về tình cảm con vật mà em đã đọc hoặc đã nghe <br>
            </div>   
          <div style='width:20cm;margin:20px 0px'>
            <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;Chuẩn bị.<br>
              - Em thích câu chuyện nào? Câu chuyện đó em đã đọc hay được nghe kể?<br>
              - Vì sao thích câu chuyện đó? (Câu chuyện có nội dung gì hấp đẫn? Nhân vật nào thú vị? Chi tiết nào ấn tượng?,...)
            </div>
            <div>
              <b style='color:rgb(3, 103, 181)'>2.</b>&ensp;Tìm ý.<br>
              <b style='margin-left:50px;color:rgb(158 59 56)'>G.</b><br>
            </div>
            <table style="border-collapse: collapse; width: 100%; max-width: 600px; margin: 20px auto;">

                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left; background-color: #0074D9">Mở đầu</td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;">Giới thiệu tên câu chuyện và nêu ý kiến chung về câu chuyện</td>
                  </tr>
                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left; background-color: #0074D9">Triển khai</td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;">Nêu một hoặc một số lí do yêu thích câu chuyện, chọn dẫn chứng cụ thể</td>
                  </tr>
                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left; background-color: #0074D9">Kết thúc</td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;">Khẳng định lại ý kiến đã nêu về câu chuyện</td>
                  </tr>

            </table>
        
      </div>
            <div>
              <b style='color:rgb(3, 103, 181)'>3.</b>&ensp;Góp ý và chỉnh sửa.<br>
              - Thông tin về câu chuyện rõ ràng, đầy đủ.<br>
              - Lý do yêu thích câu chuyện, được trình bày thuyết phục, có dẫn chứng cụ thể.
            </div>
           
          <div style='display:flex;margin-left:-140px'>
            <img src='/img/FriendsPlus/Page5/E3/1.jpg' style='height:15mm;margin-right:50px' /> 
            <div>
              Viết, vẽ,... lên một tấm bìa cứng để giới thiệu bản thân.<br>
              - Chú ý tạo sự độc đáo để nêu bật những nét riêng của mình.<br>
              - Nhớ viết hoa danh từ riêng (nếu có).<br>
            </div>
          </div>
              <b style='font-weight:bold'>
                 Bài làm:
              </b>
                    <textarea id='0' rows='8'></textarea>

        `,
        answer: ["Do",  "has",  "doesn't",  "Does" , "'m",  "'re", 
           "having",  "aren't" , "isn't",  "Is"
          
        ],
      },
    ],
  },

  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E4",
    audio: "",
    video: "",
    // recorder: true,
    // exerciseKey: "img/FriendsPlus/Page5/E4/Key/answerKey.png",
    component: T6,
    textareaStyle: { width: 300 },
    // hideBtnFooter:true,
    isEssay: true,
    questionImage: [],
    titleQuestion: [
      {
        num: "4.",
        title: `
       Tìm danh từ theo mỗi nhóm dưới đây.
				`,
        color: "rgb(3, 103, 181)",
        // star:3
      },
    ],
    questions: [
      {
        title: `
      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ chỉ một dụng cụ học tập
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='0' rows='4'></textarea>
          </div>
        </div>
        <div style='margin:0 20px'>
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ gọi tên một người bạn
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='1' rows='4'></textarea>
          </div>
        </div>
        <div >
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ chung chỉ một nghề
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='2' rows='4'></textarea>
          </div>
        </div>
      </div>

      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:15px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:75mm;text-align:center '>
            Danh từ gọi tên 1 con đường, con phố.
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='3' rows='4'></textarea>
          </div>
        </div>
        <div style='margin:0 20px'>
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ gọi tên một người bạn
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='4' rows='4'></textarea>
          </div>
        </div>
        <div >
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ chung chỉ một nghề
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='5' rows='4'></textarea>
          </div>
        </div>
      </div>
      
        
        `,
        answer: ["","","","","","",],
      },
    ],
  },
};

export default json;
